import { Slide } from '@material-ui/core'
import { useState } from 'react'

import { values } from '../../utils'

import { CategoryList } from './CategoryList'

type Maybe<T> = T | null
export interface CategorySub {
  id?: Maybe<string>
  title?: Maybe<string>
  parent?: Maybe<string>
  sub?: Maybe<Maybe<CategorySub>[]>
  tags?: Maybe<Maybe<string>[]>
}
interface Props {
  categories: CategorySub[]
  onSelect: (c: null | CategorySub) => void
}
export function Category({ categories, onSelect }: Props) {
  const [path, setPath] = useState<string[]>([])
  const handleNextClick = (id: string) => {
    if (id) {
      return setPath(prev => [...prev, id])
    }
    return setPath([])
  }
  const c = path.reduce<CategorySub[]>((acc, p) => {
    return values(acc.find(c => c.id === p)?.sub || acc)
  }, categories)

  return (
    <div>
      {path.length > 0 ? (
        <Slide direction={'left'} in={path.length > 0} mountOnEnter unmountOnExit>
          <div>
            <CategoryList
              categories={c}
              path={path}
              onNextClick={handleNextClick}
              onSelect={onSelect}
            />
          </div>
        </Slide>
      ) : (
        <Slide direction={'right'} in={path.length === 0} mountOnEnter unmountOnExit>
          <div>
            <CategoryList
              categories={c}
              path={path}
              onNextClick={handleNextClick}
              onSelect={onSelect}
            />
          </div>
        </Slide>
      )}
    </div>
  )
}
